import { School } from '@maxpreps/apiserviceclients/apiModels';
import PSEUDO_SCHOOLS from '../../constants/pseudoSchools';
import { SUPPORT_INTERNATIONAL_SCHOOLS } from '../../constants/supportArticles';

export const internationalSchoolRedirectUrl = SUPPORT_INTERNATIONAL_SCHOOLS;

export const getIsInternationalSchool = (schoolData: School): boolean =>
  !schoolData?.stateCode?.trim();

export const getIsPseudoSchool = (schoolId: string): boolean =>
  PSEUDO_SCHOOLS.some(i => i.id.toLowerCase() === schoolId.toLowerCase());

export const formatCityState = (
  name?: string,
  city?: string,
  state?: string
): string => {
  const cityStateParts: string[] = [];

  if (city && (!name || name.indexOf(city) === -1)) {
    cityStateParts.push(city);
  }

  if (state) {
    cityStateParts.push(state);
  }

  if (cityStateParts.length === 0) {
    return '';
  }

  return `(${cityStateParts.join(', ')})`;
};

interface IFormatSchoolNameOptions {
  includeTermHighSchool?: boolean;
}

// will return
// 'ponderosa (shingle springs, ca)' city doesn't match school name
// 'galt (ca)' - city names school name
// 'cordova' - city and state not provided
// options can include { includeTermHighSchool }
export const formatSchoolName = (
  name: string,
  city?: string,
  state?: string,
  options: IFormatSchoolNameOptions = {}
): string => {
  if (!name) return '';

  return `${name} ${
    options.includeTermHighSchool ? 'High School' : ''
  } ${formatCityState(name, city, state)}`;
};

interface ISchoolNameParts {
  name: string;
  formattedName?: string;
  acronym?: string;
  city?: string; // Not used right now
  state?: string; // Not used right now
}

// Attempts to fit the most available information within a specified number of characters
// preformatted name > regular name (city?, state?) > acronym (city?, state?)
export const formatSchoolNameForChars = (
  parts: ISchoolNameParts,
  maxCharacters = 100
): string => {
  const { name, formattedName, acronym } = parts;

  // Return the preformatted name if it existing and meets requirements
  if (
    typeof formattedName === 'string' &&
    formattedName.length <= maxCharacters
  ) {
    return formattedName;
  }

  // Return the regular name if it fits
  if (typeof name === 'string') {
    if (name.length <= maxCharacters) return name;
    // If it doesn't fit and we don't have an acronym, then truncate it
    else if (typeof acronym !== 'string')
      return `${name.slice(0, maxCharacters - 3)}...`;
  }

  // Return the acronym
  if (typeof acronym === 'string') {
    return acronym;
  }

  return '';

  /* More advanced logic, not needed right now 4/14/22
  if (typeof name === 'string') {
    const nameCityState = `${name} ${formatCityState(undefined, city, state)}`;
    if (nameCityState.length <= maxCharacters) {
      return nameCityState;
    }

    const nameState = `${name} ${formatCityState(undefined, undefined, state)}`;
    if (nameState.length <= maxCharacters) {
      return nameState;
    }

    if (name.length <= maxCharacters) {
      return name;
    }

    if (!acronym) {
      return `${name.slice(0, maxCharacters - 3)}...`;
    }
  }
  if (typeof acronym === 'string') {
    const acronymCityState = `${acronym} ${formatCityState(
      undefined,
      city,
      state
    )}`;
    if (acronymCityState.length <= maxCharacters) {
      return acronymCityState;
    }
    const acronymState = `${acronym} ${formatCityState(
      undefined,
      undefined,
      state
    )}`;
    if (acronymState.length <= maxCharacters) {
      return acronymState;
    }
    return acronym;
  }*/
};
